import { useCallback, useEffect, useState } from 'react'

export const useTimer = (initialSeconds: number) => {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isActive, setIsActive] = useState(false)

  // Start the timer
  const start = useCallback(() => {
    setIsActive(true)
  }, [])

  // Pause the timer
  const pause = useCallback(() => {
    setIsActive(false)
  }, [])

  // Reset the timer
  const reset = useCallback(() => {
    setIsActive(false)
    setSeconds(initialSeconds)
  }, [initialSeconds])

  // Timer effect
  useEffect(() => {
    if (!isActive) return

    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 0) {
          clearInterval(interval)
          setIsActive(false)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isActive])

  return { seconds, start, pause, reset, isActive }
}
